import React from 'react';
import { HashRouter as Router, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { init } from '@rematch/core';
import * as models from './models';
import { Index, Account, Coin, Tool, Mobile } from './page/Pages';

const store = init({ models: models });
const { dispatch } = store;

function Routes() {
    return (
        <Provider store={store}>
            <Router>
                <div>
                    <Route exact path="/" component={Index} />
                    <Route exact path="/index" component={Index} />
                    <Route exact path="/account/platform" component={Account.platform} />
                    <Route exact path="/account/account" component={Account.account} />
                    <Route exact path="/coin/huobi" component={Coin.huobi} />
                    <Route exact path="/coin/huobi/detail" component={Coin.huobiDetail} />
                    <Route exact path="/coin/huobi-contract" component={Coin.huobiContract} />
                    <Route exact path="/coin/okex" component={Coin.okex} />
                    <Route exact path="/coin/okex/detail" component={Coin.okexDetail} />
                    <Route exact path="/coin/quantRobot" component={Coin.quantRobot} />
                    <Route exact path="/coin/quantRobot/detail" component={Coin.quantRobotDetail} />
                    <Route exact path="/tool/md5" component={Tool.md5} />
                    <Route exact path="/mobile/noAuth" component={Mobile.noAuth} />
                    <Route exact path="/mobile/quantRobot/detail" component={Mobile.quantRobotDetail} />
                    <Route exact path="/mobile/eat" component={Mobile.eat} />
                </div>
            </Router>
        </Provider>
    );
}

export {
    Routes,
    store,
    dispatch
}


// WEBPACK FOOTER //
// ./src/App.jsx